const WHATSAPP_MESSAGE = encodeURIComponent('Здравствуйте! Хочу обсудить проект с Kazak.V.')
const EMAIL_SUBJECT = encodeURIComponent('Новый проект для Kazak.V')
const EMAIL_BODY = encodeURIComponent('Здравствуйте, Владислав! Хочу обсудить проект.')

export const CONTACTS = {
  telegram: {
    label: 'Telegram',
    value: '@Megan_1337',
    href: 'https://t.me/Megan_1337',
  },
  whatsapp: {
    label: 'WhatsApp',
    value: '+7 920 429-58-46',
    href: `https://wa.me/79204295846?text=${WHATSAPP_MESSAGE}`,
  },
  email: {
    label: 'Почта',
    value: 'ligamentumflava@gmail.com',
    href: `mailto:ligamentumflava@gmail.com?subject=${EMAIL_SUBJECT}&body=${EMAIL_BODY}`,
  },
}
